import { render, staticRenderFns } from "./VerticalSliders.vue?vue&type=template&id=64647d90&"
import script from "./VerticalSliders.vue?vue&type=script&lang=js&"
export * from "./VerticalSliders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports